// Mock data for Market Sentinel AI website

export const mockData = {
  // App Store Links (placeholders)
  appStoreLinks: {
    googlePlay: "https://play.google.com/store",
    appStore: "https://apps.apple.com/"
  },

  // Logo
  logo: {
    url: "https://customer-assets.emergentagent.com/job_ai-trading-11/artifacts/d7dxhgjv_sentinel%20logo.png",
    alt: "Market Sentinel AI Logo"
  },

  // Hero Section
  hero: {
    title: "Market Sentinel AI",
    subtitle: "AI-powered trading intelligence for global markets.",
    ctaText: "Download the App"
  },

  // What Sentinel Does
  features: [
    "Scan global markets automatically",
    "Detect trading opportunities",
    "Generate clear trade insights",
    "Send real-time alerts"
  ],

  // How It Works
  howItWorks: [
    {
      step: 1,
      title: "Sentinel scans global markets",
      description: "Automated algorithms analyze crypto, forex, and macro assets continuously"
    },
    {
      step: 2,
      title: "AI detects potential opportunities",
      description: "Multi-timeframe analysis identifies high-probability setups"
    },
    {
      step: 3,
      title: "Users receive clear market insights",
      description: "Get actionable intelligence delivered directly to your mobile device"
    }
  ],

  // Key Features
  keyFeatures: [
    {
      title: "Market Narrative",
      description: "Overview of global market conditions",
      icon: "TrendingUp"
    },
    {
      title: "Top Opportunity",
      description: "The strongest setup detected by Sentinel",
      icon: "Target"
    },
    {
      title: "Watchtower Alerts",
      description: "Real-time notifications when opportunities appear",
      icon: "Bell"
    },
    {
      title: "AI Trade Plan",
      description: "Clear guidance explaining the setup",
      icon: "FileText"
    },
    {
      title: "Multi-timeframe Analysis",
      description: "Signals confirmed across multiple timeframes",
      icon: "BarChart3"
    }
  ],

  // Asset Classes
  assetClasses: [
    "BTC, ETH",
    "EURUSD, GBPUSD",
    "SP500, Gold, DXY"
  ],

  // Footer
  currentYear: new Date().getFullYear(),
  companyName: "Market Sentinel AI"
};
